function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.12492 1.0835H4.87492C4.57576 1.0835 4.33325 1.32601 4.33325 1.62516V2.7085C4.33325 3.00765 4.57576 3.25016 4.87492 3.25016H8.12492C8.42407 3.25016 8.66659 3.00765 8.66659 2.7085V1.62516C8.66659 1.32601 8.42407 1.0835 8.12492 1.0835Z",
  stroke: "black",
  strokeWidth: 1.08333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.66675 2.1665H9.75008C10.0374 2.1665 10.3129 2.28064 10.5161 2.4838C10.7193 2.68697 10.8334 2.96252 10.8334 3.24984V10.8332C10.8334 11.1205 10.7193 11.396 10.5161 11.5992C10.3129 11.8024 10.0374 11.9165 9.75008 11.9165H3.25008C2.96276 11.9165 2.68721 11.8024 2.48405 11.5992C2.28088 11.396 2.16675 11.1205 2.16675 10.8332V3.24984C2.16675 2.96252 2.28088 2.68697 2.48405 2.4838C2.68721 2.28064 2.96276 2.1665 3.25008 2.1665H4.33341",
  stroke: "black",
  strokeWidth: 1.08333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 5.9585H8.66667",
  stroke: "black",
  strokeWidth: 1.08333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 8.6665H8.66667",
  stroke: "black",
  strokeWidth: 1.08333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.33325 5.9585H4.33867",
  stroke: "black",
  strokeWidth: 1.08333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.33325 8.6665H4.33867",
  stroke: "black",
  strokeWidth: 1.08333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgAssignmentsFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentsFilterIcon);
export default __webpack_public_path__ + "static/media/assignments-filter-icon.0af00923.svg";
export { ForwardRef as ReactComponent };